import React, { useState, useEffect } from 'react';
import ReviewPopupKYC from './review-popup';
import DocumentPreview from '../Create-Investment/documentpreview';
import ActivityLog from '../../Components/ActivityLog/activity-log';
import SectionStatusGrid from '../../Components/Onbaording/status-section';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import { useSelector } from 'react-redux';
// import { debounce } from "lodash";
import EDDModal from '../Risk-Assessment/edd-modal';
import UserQuestionnaire from '../Risk-Assessment/user-questionnarie';
import StatusButton from '../../Components/Onbaording/status-button';
import FileUploadDisplay from '../../Components/Onbaording/file-display';
import AuditStepper from '../../Components/Onbaording/onboarding-stepper';
import { formatDateTimeUTC } from '../../Constants/helper-functions';

const steps = [
  {
    key: 'submitted',
    label: 'Application Submitted',
    icon: 'description',
    status: 'completed',
  },
  // {
  //   key: 'sanction',
  //   label: 'Sanction Verified',
  //   icon: 'gavel',
  //   status: 'completed',
  // },
  {
    key: 'identity',
    label: 'Identity Verified',
    icon: 'verified_user',
    status: 'completed',
  },
  {
    key: 'manual',
    label: 'Manual Review',
    icon: 'manage_search',
    status: 'active',
  },
  {
    key: 'approved',
    label: 'Approved',
    icon: 'check_circle',
    status: 'pending',
  },
];
const ReviewKycReadOnly = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { customerId } = useParams();
  const navigate = useNavigate();
  const [sanctionResults, setSanctionResults] = useState(null);
  const updateFieldStatus = useSelector(
    (state) => state.form.updateFieldStatus,
  );
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [meetingData, setMeetingData] = useState([]);

  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const roleName = useSelector((state) => state.user.roleName);
  const [showModal, setShowModal] = useState(false);
  const [eddResponse, setEddResponse] = useState(null);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const location = useLocation();
  const { showToast } = useToast();
  const [steps, setSteps] = useState([]);

  const [showPopup, setShowPopup] = useState(false);
  const [taxResidentCountry, setTaxResidentCountry] = useState(null);
  const [nonResCountryText, setNonResCountryText] = useState(null);
  const [photoIdSecondText, setphotoIdSecondText] = useState(null);
  const [photoIdSecond, setphotoIdSecond] = useState(null);
  const [isActivityLogOpen, setIsActivityLogOpen] = useState(false);
  const [fullName, setFullName] = useState(null);
  const [jointAccountName, setJointAccountName] = useState('');
  const [verificationStatus, setVerificationStatus] = useState('');
  const [dvsTime, setDvsTime] = useState('');
  const [dvsMeessage, setDvsMeessage] = useState('');
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [nonphotoIdText, setNonPhotoIdText] = useState('');
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [expiryDateSecond, setExpiryDateSecond] = useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [jointAccountID, setJointAccountID] = useState(null);
  const [accountPurpose, setAccountPurpose] = useState(null);
  const [documentNumber, setDocumentNumber] = useState(null);
  const [cardNumberSecond, setCardNumberSecond] = useState(null);
  const [cardNumber, setCardNumber] = useState(null);

  const [applicantCountry, setApplicantCountry] = useState(null);
  const [socialSecurityNumber, setSocialSecurityNumber] = useState(null);
  const [abn, setAbn] = useState(null);
  const [businessName, setBusinessName] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [accountType, setAccountType] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [currentDocument, setcurrentDocument] = useState({});
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [nameFromBirth, setNameFromBirth] = useState('');
  // const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [taxId, setTaxId] = useState(null);
  const [ownership, setOwnership] = useState(null);
  const [image, setImage] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [photoId, setphotoId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [middleName, setMiddleName] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileAttorney, setFileAttorney] = useState(null);
  const [filePurpose, setFilePurpose] = useState(null);
  const [thirdPartySign, setThirdPartySign] = useState(null);
  const [photoIdText, setPhotoIdText] = useState(null);
  const [businessActivity, setBusinessActivity] = useState(null);
  const [jointAccountMembers, setJointAccountMembers] = useState([]);
  const [jointAccountActualMembers, setJointAccountActualMembers] = useState(
    [],
  );
  const [signatory, setSignatory] = useState('yes');
  const [businessAddress, setBusinessAddress] = useState(null);
  const [transactionNature, setTransactionNature] = useState(null);

  const [photoIdFirstText, setphotoIdFirstText] = useState('');
  const [photoIdFirst, setphotoIdFirst] = useState(null);
  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [formattedDOB, setFormattedDOB] = useState('');
  const [formerNames, setFormerNames] = useState(null);
  const [redAddress, setRedAddress] = useState(null);
  const [clientNo, setClientNo] = useState(null);
  const [fundSource, setFundSource] = useState(null);
  const [description, setDescription] = useState(null);
  const [fileProof, setFileProof] = useState(null);
  const [documentNumberSecond, setDocumentNumberSecond] = useState(null);
  const [mobileNumber, setMobileNumber] = useState('');
  const [customerType, setCustomerType] = useState('');
  const [lastNameSignup, setLastNameSignup] = useState('');
  const [firstNameSignup, setFirstNameSignup] = useState('');
  const [email, setEmail] = useState('');
  const [statusData, setStatusData] = useState([]);
  const mapQuestions = (questions = []) => {
    const typeMap = {
      text: 1,
      radio: 2,
      select: 3,
      checkbox: 5,
      checkbox_with_percent: 4,
      multi_select: 6,
      file: 8,
    };

    return questions.map((q) => ({
      id: q.id,
      question: q.question_text,
      required: q.required,
      type: {
        value: typeMap[q.type.value] || 1,
      },
      options: (q.options || []).map((opt) => ({
        id: opt.id,
        label: opt.value,
        value: opt.value,
      })),
      answer: q.answer,
    }));
  };
  const latest = sanctionResults?.latest;

  const fullNameSanction = latest?.request_payload?.full_name || '-';
  const screeningDate = latest?.response_timestamp || '-';

  const uiMessage = latest?.ui?.message;
  const uiSummary = latest?.ui?.summary;
  const sourcesChecked =
    latest?.response_payload?.data?.evidence?.sources_checked || [];

  const matchedSources = latest?.matched_sources || [];
  const decision = latest?.decision || {};
  const getSourceStyle = (source, isMatched) => {
    if (isMatched) {
      return 'bg-gradient-to-r from-red-50 to-pink-50 text-red-600 border-red-200';
    }

    return 'bg-blue-50 text-blue-600 border-blue-200';
  };
  const formatSourceName = (source) => {
    return source
      ?.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };
  const getComplianceStatus = () => {
    if (!decision) return { label: '-', color: 'text-gray-500', sub: '' };

    if (!decision.pep && !decision.sanctions && !decision.adverse_media) {
      return {
        label: 'Clear',
        color: 'text-green-600',
        sub: uiMessage || 'No risk detected',
      };
    }

    if (decision.sanctions) {
      return {
        label: 'High Risk',
        color: 'text-red-600',
        sub: 'Sanctions match found',
      };
    }

    return {
      label: 'Review Required',
      color: 'text-amber-600',
      sub: 'Further checks recommended',
    };
  };

  const compliance = getComplianceStatus();
  const getStatusSanction = (val) => (val ? 'found' : 'completed');

  const sanctionsStatus = getStatusSanction(decision?.sanctions);
  const pepStatus = getStatusSanction(decision?.pep);
  const adverseStatus = getStatusSanction(decision?.adverse_media);
  const pendingQuestions = mapQuestions(
    (eddResponse?.pending || []).flatMap((item) => item.questions || []),
  );

  const completedQuestions = mapQuestions(
    (eddResponse?.completed || []).flatMap((item) => item.questions || []),
  );
  const completedGroups = (eddResponse?.completed || []).map((item) => ({
    id: item.id,
    requestedBy: item.requested_by?.name,
    respondedAt: item.responded_at,
    questions: mapQuestions(item.questions || []),
  }));
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  function formatDateTime(dateString) {
    if (!dateString) return '-';

    try {
      // remove timezone abbreviations like AEDT, AEST etc.
      const cleaned = dateString.replace(/\b[A-Z]{3,4}\b/g, '').trim();

      const parts = cleaned.split(' ');
      const [day, month, year] = parts[0].split('/');

      let [hour] = parts[1].split(':');
      const period = parts[2];

      hour = parseInt(hour);

      // convert 12h → 24h
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;

      return `${day}/${month}/${year}`;
    } catch (e) {
      return '-';
    }
  }
  const getAllDetails = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}`
          : `/api/v1/agency/customers/review/${customerId}`,
      );

      if (response.status == 200) {
        // Open account status
        setFirstNameSignup(
          response.data.open_account_information.first_name.value,
        );
        setLastNameSignup(
          response.data.open_account_information.last_name.value,
        );
        setEmail(response.data.open_account_information.email_address.value);
        setMobileNumber(
          response.data.open_account_information.country_code.value +
            response.data.open_account_information.mobile_number.value,
        );
        setCustomerType(
          response.data.open_account_information.account_type.value,
        );
        //Personal info
        setProfilePic(response.data.personal_information.profile_picture_file);
        setFirstName(response.data.personal_information.first_name);
        setAccountType(response.data.personal_information.account_type);
        setApplicantCountry(
          response.data.personal_information.applicant_country,
        );
        setSocialSecurityNumber(
          response.data.personal_information.social_security_number,
        );
        setLastName(response.data.personal_information.last_name);
        setMiddleName(response.data.personal_information.middle_name);
        setNameFromBirth(response.data.personal_information.is_birth_name);
        setFullName(response.data.personal_information.first_name);
        setFormerNames(response.data.personal_information.former_names);
        const date = new Date(response.data.personal_information.dob.value);
        const formattedDate = date.toLocaleDateString('en-GB');
        setFormattedDOB(formattedDate);
        setRedAddress(response.data.personal_information.address);
        setClientNo(response.data.open_account_information.client_id);
        if (roleName == 'agency_compliance') {
          setMeetingData(response.data.agent_meeting_flags);
        }

        if (
          response.data.personal_information.account_type.id != 1 &&
          response.data.personal_information.account_type.id != 5
        ) {
          setJointAccountID(
            response.data.personal_information.joint_account.unique_id,
          );
          // Invites
          if (
            response.data.personal_information.joint_account.invitations
              .length > 0
          ) {
            const transformed =
              response.data.personal_information.joint_account.invitations.map(
                (item) => {
                  const apiAddress = item.address;

                  // Safely transform backend address to the structure your component expects
                  const formattedAddress = apiAddress
                    ? {
                        full: apiAddress.google_address || '',
                        street: apiAddress.street_number
                          ? `${apiAddress.street_number} ${
                              apiAddress.street_name || ''
                            }`.trim()
                          : apiAddress.address_line_1 || '',
                        route: apiAddress.address_line_2 || '',
                        city: apiAddress.city?.name || '',
                        state: apiAddress.state?.name || '',
                        country: apiAddress.country?.name || '',
                        zip: apiAddress.postal_code || '',
                        comments: apiAddress.comments,
                        rejection_comment: apiAddress.rejection_comment,
                        rejection_reason: apiAddress.rejection_reason,
                        status: apiAddress.status,
                      }
                    : {
                        full: '',
                        street: '',
                        route: '',
                        city: '',
                        state: '',
                        country: '',
                        zip: '',
                      };

                  return {
                    firstName: item.invitee_first_name || '',
                    lastName: item.invitee_last_name || '',
                    email: item.invitee_email || '',
                    countryCode: item.invitee_country_code || 'AU(+61)',
                    mobile: item.invitee_mobile_number || '',
                    address: formattedAddress,
                    errors: {
                      email: '',
                      mobile: '',
                    },
                  };
                },
              );

            setJointAccountMembers(transformed);
          }
          // Members
          if (
            response.data.personal_information.joint_account.members.length > 0
          ) {
            const transformed =
              response.data.personal_information.joint_account.members
                .filter((item) => item.is_invitee) // only keep invitees
                .map((item) => {
                  return {
                    firstName: item.first_name || '',
                    lastName: item.last_name || '',
                    email: item.email || '',
                    userId: item.user_id || '',
                  };
                });
            setJointAccountActualMembers(transformed);
            let jointUserSoleSignatory =
              response.data.personal_information.joint_account.members.filter(
                (item) => item.is_sole_signatory.value == true,
              );
            if (jointUserSoleSignatory.length > 0) {
              setJointAccountName(
                jointUserSoleSignatory[0].first_name.value +
                  ' ' +
                  jointUserSoleSignatory[0].first_name.value,
              );
            } else {
              setJointAccountName('Myself');
            }
          }
          setSignatory(
            response.data.personal_information.is_any_sole_signatory == true
              ? 'yes'
              : 'no',
          );
          setFileAttorney(
            response.data.personal_information.power_of_attorney_file,
          );
        }

        //Business info
        if (response.data.personal_information.account_type.id == 5) {
          setTaxResidentCountry(
            response.data.business_information.tax_resident_country,
          );
          setNonResCountryText(response.data.business_information.country);
          setBusinessRegistrationNumber(
            response.data.business_information.business_registration_number,
          );
          setAbn(response.data.business_information.abn);
          setTaxId(response.data.business_information.tax_id);
          setBusinessName(response.data.business_information.business_name);
          setBusinessActivity(
            response.data.business_information.business_activity,
          );
          setFundSource(response.data.business_information.source_of_funds);
          setAccountPurpose(
            response.data.business_information.purpose_of_opening_account,
          );
          setFilePurpose(response.data.business_information.documents[0]);
          setBusinessAddress(response.data.business_information.address);
          setTransactionNature(
            response.data.business_information
              .nature_n_level_of_intended_transactions,
          );
          setOwnership(
            response.data.business_information
              .beneficial_ownership_with_ratified,
          );
        }

        // //Prove you
        setImage(response.data.liveness_proof.selfie);
        // // Upload docs
        setThirdPartySign(
          response.data.proof_documents.has_prosecution_history,
        );
        setDescription(response.data.proof_documents.prosecution_description);
        setFileProof(response.data.proof_documents.prosecution_file);
        setExpiryDate(
          response.data.proof_documents.photographic_documents[0].expiry_date,
        );
        if (
          response.data.personal_information.applicant_country.value.id == 14
        ) {
          setExpiryDate(
            response.data.proof_documents.photographic_documents[0].expiry_date,
          );
          setphotoId(
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.id,
          );
          setDocumentNumber(
            response.data.proof_documents.photographic_documents[0]
              .document_number,
          );
          setCardNumber(
            response.data.proof_documents.photographic_documents[0]
              ?.card_number,
          );
          setPhotoIdText(
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.name,
          );

          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.id != 2
          ) {
            setFilePhotographicId(
              response.data.proof_documents.photographic_documents[0].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.id == 2
          ) {
            setFileDriverLinsenceFront(
              response.data.proof_documents.photographic_documents[0].file,
            );
            setFileDriverLinsenceBack(
              response.data.proof_documents.photographic_documents[0].back_file,
            );
          }
        }

        if (
          response.data.personal_information.applicant_country.value.id != 14
        ) {
          console.log(
            'sjsjjs' +
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id,
          );
          setphotoIdFirst(
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.id,
          );
          setphotoIdFirstText(
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.name,
          );
          if (response.data.proof_documents.photographic_documents[1]) {
            setphotoIdSecond(
              response.data.proof_documents.photographic_documents[1]
                .document_type.value.id,
            );
            setphotoIdSecondText(
              response.data.proof_documents.photographic_documents[1]
                .document_type.value.name,
            );
            setDocumentNumberSecond(
              response.data.proof_documents.photographic_documents[1]
                .document_number,
            );
            setCardNumberSecond(
              response.data.proof_documents.photographic_documents[1]
                ?.card_number,
            );
            setExpiryDateSecond(
              response.data.proof_documents.photographic_documents[1]
                .expiry_date,
            );
          }

          setDocumentNumber(
            response.data.proof_documents.photographic_documents[0]
              .document_number,
          );
          setCardNumber(
            response.data.proof_documents.photographic_documents[0]
              ?.card_number,
          );
          setExpiryDate(
            response.data.proof_documents.photographic_documents[0].expiry_date,
          );

          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.id != 2
          ) {
            setfilePhotographicIdFirst(
              response.data.proof_documents.photographic_documents[0].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.id == 2
          ) {
            setFileDriverLinsenceFrontFirst(
              response.data.proof_documents.photographic_documents[0].file,
            );
            setFileDriverLinsenceBackFirst(
              response.data.proof_documents.photographic_documents[0].back_file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[1] &&
            response.data.proof_documents.photographic_documents[1]
              .document_type.value.id != 2
          ) {
            setfilePhotographicIdSecond(
              response.data.proof_documents.photographic_documents[1].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[1] &&
            response.data.proof_documents.photographic_documents[1]
              .document_type.value.id == 2
          ) {
            setFileDriverLinsenceFrontSecond(
              response.data.proof_documents.photographic_documents[1].file,
            );
            setFileDriverLinsenceBackSecond(
              response.data.proof_documents.photographic_documents[1].back_file,
            );
          }
        }
        setNonPhotoIdText(
          response.data.proof_documents.non_photogenic_id_type_name,
        );
        setfileNonPhotographicId(
          response.data.proof_documents.non_photogenic_file,
        );
        setVerificationStatus(
          response.data.dvs_checks?.latest?.verification_result_code,
        );
        setDvsMeessage(
          response.data.dvs_checks?.latest?.verification_result_message,
        );
        setDvsTime(response.data.dvs_checks?.latest?.created_at);
        setSanctionResults(response.data.sanctions_checks);
        setIsDataAvailable(true);
      }
    } catch (err) {
      setIsDataAvailable(false);
      showToast(err.message, 'error');
    } finally {
      //    setIsDataAvailable(true);
    }
  };
  const getEddResponses = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/edd-responses`
          : `/api/v1/agency/customers/review/${customerId}/edd-responses`,
      );
      if (response.status == 200) {
        setEddResponse(response.data);
      }
    } catch (err) {
      setEddResponse({});
      showToast(err.message, 'error');
    }
  };
  const getStatus = async () => {
    try {
      setLoading(true);
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/sections`
          : `/api/v1/agency/customers/review/${customerId}/sections`,
      );

      if (response.status == 200) {
        setStatusData(response.data.sections);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  const getOverallJourney = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/overall-status`
          : `/api/v1/agency/customers/review/${customerId}/overall-status`,
      );
      const stageIconMap = {
        application_submitted: 'description',
        sanction_verification: 'gavel',
        identity_verification: 'verified_user',
        manual_review: 'manage_search',
        approved: 'check_circle',
        rejected: 'cancel',
        resubmission: 'refresh',
      };
      if (response.status == 200) {
        const stages = response.data?.stages || [];

        const mappedStages = stages.map((item) => ({
          ...item,
          key: item.stage,
          icon: stageIconMap[item.stage] || 'circle',
        }));

        setSteps(mappedStages);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  // const updateSection = async (action, sectionId) => {
  //   const token = localStorage.getItem("jwtToken");
  //   const headers = {
  //     "Content-Type": "application/json",
  //   };

  //   if (token) {
  //     headers.Authorization = `Bearer ${token}`;
  //   }
  //   const apiUrl =
  //     roleName == "agent"
  //       ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/complete-section`
  //       : `${BASE_URL}/api/v1/agency/customers/review/${customerId}/complete-section`;
  //   const bodyData = {
  //     section_id: sectionId,
  //     action: action,
  //     user_id: customerId,
  //   };
  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: "PUT",
  //       headers: headers,
  //       body: JSON.stringify(bodyData),
  //     });

  //     if (!response.ok) {
  //       if (response.status === 401) {
  //         localStorage.removeItem("jwtToken");
  //         navigate("/login");
  //         throw new Error("Session expired. Please log in again.");
  //       }
  //       const errorData = await response.json().catch(() => ({
  //         message: "An unexpected error occurred",
  //       }));

  //       throw new Error(errorData.message || "Something went wrong");
  //     }

  //     return await response.json();
  //   } catch (error) {
  //     throw new Error(error.message || "Network error, please try again later");
  //   }
  // };
  // const handleUpdateSection = useCallback(
  //   debounce(async (action, sectionId) => {
  //     let toastMessage = null;
  //     try {
  //       const response = await updateSection(action, sectionId);
  //       if (response.status == 200) {
  //         toastMessage = {
  //           message: response.message,
  //           type: "success",
  //         };
  //         getStatus();
  //         getAllDetails();
  //       } else {
  //         toastMessage = { message: response.message, type: "error" };
  //       }
  //     } catch (error) {
  //       toastMessage = { message: error.message, type: "error" };
  //     } finally {
  //       setLoadingUpdate(false); // Ensure `loading` is false first
  //       // Show toast after loading is false
  //       if (toastMessage) {
  //         setTimeout(() => {
  //           showToast(toastMessage.message, toastMessage.type);
  //         }, 1000); // Small delay if needed
  //       }
  //     }
  //   }, 1000),
  //   [customerId], // Dependencies
  // );
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    setShowPopup(true);
  };
  const kycheaders = [
    '',
    'Full Name',
    'Date Of Birth',
    'Email Address',
    'Mobile Number',
    'Account Type',
  ];
  const memberHeaders = ['', 'First name', 'Last name', 'Email Address'];
  const secondheadersWithAddress = [
    '',
    'First Name',
    'Last Name',
    'Date Of Birth',
    'Email Address',
    'Mobile Number',
    'Residential Address',
    'Account Type',
  ];
  const requestReviewAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/agent/customers/${customerId}/request-access-upgrade`;
    let bodyData = {
      requested_level: 3,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleReviewRequest = async () => {
    let toastMessage = null;
    try {
      const response = await requestReviewAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: 'success',
        };
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  useEffect(() => {
    if (customerId || updateFieldStatus) {
      getStatus();
      getAllDetails();
      getOverallJourney();
    }
  }, [customerId, updateFieldStatus]);

  useEffect(() => {
    if (customerId) {
      getEddResponses();
    }
  }, [customerId]);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] p-4 bg-white rounded-lg shadow-lg  relative">
      {/* {loadingUpdate && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )} */}
      {loading ? (
        <div className="space-y-6">
          {/* Content Shimmer */}
          {[...Array(5)].map((_, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gray-300 animate-shimmer"></div>
              <div className="h-4 w-full max-w-3xl bg-gray-300 rounded animate-shimmer"></div>
            </div>
          ))}

          {/* Buttons Shimmer */}
          <div className="flex flex-wrap gap-2 mt-4">
            <div className="h-10 w-48 bg-gray-300 rounded-xl animate-shimmer"></div>
            <div className="h-10 w-56 bg-gray-300 rounded-xl animate-shimmer"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img src="/note-2.svg" alt="Company Logo" className="mr-3" />
              <span className="font-medium lg:text-lg text-sm">Review KYC</span>
            </div>
            <div className="flex gap-2 mt-4 md:mt-0">
              <button
                onClick={() => {
                  setLoading(true);
                  handleReviewRequest();
                }}
                className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl"
              >
                <img src="/send-message.svg" alt="Add Icon" className="mr-2" />
                <span className="lg:inline hidden pr-2">
                  Request Review Access
                </span>
              </button>
              {/* <button className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl">
                <img src="/send-message.svg" alt="Add Icon" className="mr-2" />
                <span className="lg:inline hidden pr-2">
                  Check Matching Details
                </span>
                <span className="bg-[#FF5050] text-xs flex items-center justify-center text-white w-5 h-5 rounded-full ml-2">
                  2
                </span>
              </button> */}
            </div>
          </div>

          <div>
            <div className="flex flex-wrap justify-between p-4  items-center mb-4">
              <div className="flex items-center w-full md:w-auto mb-4 md:mb-0">
                <div className="flex flex-col md:flex-row md:items-center w-full md:w-auto">
                  <h1 className="text-md font-medium mr-2">
                    {firstNameSignup} {lastNameSignup}
                  </h1>
                </div>
              </div>
              <div className="flex space-x-2 w-full md:w-auto">
                <button
                  onClick={() => {
                    setIsActivityLogOpen(true);
                  }}
                  className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl w-full md:w-auto"
                >
                  <img
                    src="/backward-10-seconds.svg"
                    alt="Add Icon"
                    className="mr-2"
                  />
                  <span className="inline pr-2">Activity Log</span>
                </button>
              </div>
            </div>
            {isActivityLogOpen && (
              <ActivityLog
                onClose={() => setIsActivityLogOpen(false)}
                customerId={customerId}
              />
            )}
            <div className="w-full  p-4">
              <AuditStepper steps={steps} />
              <div className="w-full mt-4 rounded-2xl border border-slate-200 bg-white px-4 py-6 md:px-7 md:py-7 shadow-[0_4px_20px_rgba(15,23,42,0.04)]">
                <SectionStatusGrid sections={statusData} />
              </div>
            </div>
          </div>
          {isDataAvailable && (
            <>
              {/* Open Account Information */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/profile-circle-black.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {' '}
                        Open Account Information
                      </h1>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {/* Column 1 */}
                    <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4">
                      <label className="text-sm text-[#A6A6A6]">
                        First Name
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {firstNameSignup}
                      </div>

                      <label className="mt-2 text-sm text-[#A6A6A6]">
                        Last Name
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {lastNameSignup}
                      </div>
                    </div>

                    {/* Column 2 */}
                    <div className="flex flex-col lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <label className="text-sm text-[#A6A6A6]">Email</label>
                      <div className="text-sm break-all whitespace-normal max-w-full">
                        {email}
                      </div>

                      <label className="mt-2 text-sm text-[#A6A6A6]">
                        Mobile
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {mobileNumber}
                      </div>
                    </div>

                    {/* Column 3 */}
                    <div className="flex flex-col lg:pt-4 pt-0 px-4">
                      <label className="text-sm text-[#A6A6A6]">
                        Customer Type
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {customerType.name}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showPopup && currentField && (
                <ReviewPopupKYC
                  isOpen={showPopup}
                  currentField={currentField}
                  currentFieldName={currentFieldName}
                  currentFieldValue={currentFieldValue}
                  currentFieldType={currentFieldType}
                  onClose={() => setShowPopup(false)}
                />
              )}
              {/* End  */}
              {/* Personal Information */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/profile-circle-black.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {' '}
                        Personal Information
                      </h1>
                    </div>
                  </div>
                  {/* Will add popup here */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4 ">
                      {profilePic.value && (
                        <>
                          {' '}
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Profile Picture
                            </label>
                          </div>
                          <img
                            src={profilePic.value?.presigned_url}
                            alt={`${firstName.value}`}
                            className="w-16 h-16 rounded-full object-cover"
                          />
                        </>
                      )}
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Type Of Customer
                        </label>
                      </div>
                      <div className="mt-0 text-sm">
                        {accountType ? accountType.value.name : ''}
                      </div>
                      {applicantCountry.value.id == 233 && (
                        <>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Social Security Number
                            </label>
                          </div>
                          <div className="mt-0 text-sm">
                            {socialSecurityNumber.value}
                          </div>
                        </>
                      )}
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Is this name from birth?
                        </label>
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="birthName"
                            value={true}
                            checked={nameFromBirth.value == true}
                            disabled={true}
                            className="w-4 h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="birthName"
                            value={false}
                            disabled={true}
                            checked={nameFromBirth.value == false}
                            className="w-4 h-4  border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          First Name
                        </label>
                      </div>
                      <div className="mt-0 text-sm">{fullName.value}</div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Last Name
                        </label>
                      </div>
                      <div className="mt-0 text-sm">{lastName.value}</div>

                      {middleName && middleName.value && (
                        <>
                          {' '}
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Middle Name
                            </label>
                          </div>
                          <div className="mt-0 text-sm">{middleName.value}</div>
                        </>
                      )}
                      {formerNames.value.length > 0 && (
                        <>
                          <div className="flex mt-2  items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Customer's Former Name(s)
                            </label>
                          </div>
                          <div className="mt-0 text-sm">
                            {formerNames.value}
                          </div>
                        </>
                      )}
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Date of Birth
                        </label>
                      </div>
                      <div className="mt-0 text-sm">{formattedDOB}</div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Applicant's Country
                        </label>
                      </div>
                      <div className="mt-0 text-sm">
                        {applicantCountry.value.name}
                      </div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Residential Address
                        </label>
                      </div>
                      <div className="mt-0 text-sm">
                        {redAddress.value.google_address}
                      </div>
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col px-4">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Client No
                        </label>
                      </div>
                      <div className="mt-0 text-sm">{clientNo?.value}</div>
                      {accountType &&
                        accountType.value.id != 1 &&
                        accountType.value.id != 5 && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Joint Account ID
                              </label>
                            </div>
                            <div className="mt-0 text-sm">
                              {jointAccountID.value}
                            </div>
                          </>
                        )}
                    </div>
                  </div>
                  {accountType.value.id != 1 && accountType.value.id != 5 && (
                    <div className="w-full p-4">
                      <div className="border-t">
                        <div className="flex items-center justify-between border-colour-custom pt-2">
                          <div className="flex  text-black items-center space-x-2">
                            <h1 className="text-md font-medium mb-2">
                              {' '}
                              Joint Account Invites{' '}
                            </h1>
                          </div>
                        </div>
                        <div className="overflow-x-auto border-b ">
                          <table className="w-full h-full border-separate text-xs pb-4 border-[#EDEDED] border-spacing-y-2">
                            {/* Table Header */}
                            <thead className="text-[#8C8C8C] text-left text-sm">
                              {accountType.value.id != 4 && (
                                <tr className="border border-[#EDEDED]">
                                  {kycheaders.map((header, index) => (
                                    <th
                                      key={header}
                                      className={`
            cursor-pointer px-2 py-2 mb-5 text-left font-medium
            ${index === 0 ? 'w-8' : 'w-40'} /* Make the first column narrower */
            ${
              index === 0
                ? 'border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]'
                : ''
            }
            ${
              index >= 1 && index <= 4
                ? 'border-t border-b border-[#EDEDED]'
                : ''
            }
            ${
              index === 5
                ? 'border-t border-b border-r rounded-tr-md rounded-br-md border-[#EDEDED]'
                : ''
            }
          `}
                                    >
                                      <span>{header}</span>
                                    </th>
                                  ))}
                                </tr>
                              )}
                              {accountType.value.id == 4 && (
                                <tr className="border border-[#EDEDED]">
                                  {secondheadersWithAddress.map(
                                    (header, index) => (
                                      <th
                                        key={header}
                                        className={`
            cursor-pointer px-2 py-2 mb-5 text-left font-medium
            ${index === 0 ? 'w-8' : 'w-40'} /* Make the first column narrower */
            ${
              index === 0
                ? 'border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]'
                : ''
            }
            ${
              index >= 1 && index <= 6
                ? 'border-t border-b border-[#EDEDED]'
                : ''
            }
            ${
              index === 7
                ? 'border-t border-b border-r rounded-tr-md rounded-br-md border-[#EDEDED]'
                : ''
            }
          `}
                                      >
                                        <span>{header}</span>
                                      </th>
                                    ),
                                  )}
                                </tr>
                              )}
                            </thead>
                            <tbody className="text-sm font-medium text-black">
                              {jointAccountMembers.length > 0 ? (
                                jointAccountMembers.map((member, idx) => (
                                  <tr key={idx} className="mb-2 bg-[#F9F9F9]">
                                    <td className="px-4 py-2 text-[#8C8C8C] w-8">
                                      {(idx + 1).toString().padStart(2, '0')}.
                                    </td>{' '}
                                    {/* Set width for first column */}
                                    <td className="px-2 text-left py-4 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                      <div className="flex flex-col text-left sm:flex-row justify-between items-start sm:items-center w-full gap-2">
                                        <span className="break-words w-full sm:w-auto">
                                          {member.firstName.value}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="px-2 text-left py-4 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                      <div className="flex flex-col text-left sm:flex-row justify-between items-start sm:items-center w-full gap-2">
                                        <span className="break-words w-full sm:w-auto">
                                          {member.lastName.value}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="px-2 py-4 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full gap-2">
                                        <span className="break-words w-full sm:w-auto">
                                          {member.dob.value}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="px-2 py-4 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full gap-2">
                                        <span className="break-words w-full sm:w-auto">
                                          {member.email.value}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="px-2 py-4 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full gap-2">
                                        <span className="break-words w-full sm:w-auto">
                                          <span className="text-[#888888]">
                                            {member.countryCode.value}{' '}
                                          </span>
                                          {member.mobile.value}
                                        </span>
                                      </div>
                                    </td>
                                    {accountType.value.id == 4 && (
                                      <td className="px-2 py-4 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full gap-2">
                                          <span className="break-words w-full sm:w-auto">
                                            {member.address.full}
                                          </span>
                                        </div>
                                      </td>
                                    )}
                                    <td className="px-2 py-4 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full gap-2">
                                        <span className="break-words w-full sm:w-auto">
                                          {member.accountType == 'individual'
                                            ? 'Individual'
                                            : 'Corporate'}{' '}
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="text-center py-4" colSpan="7">
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                  {accountType.value.id != 1 && accountType.value.id != 5 && (
                    <div className="w-full p-4">
                      <div className="border-t">
                        <div className="flex items-center justify-between border-colour-custom pt-2">
                          <div className="flex  text-black items-center space-x-2">
                            <h1 className="text-md font-medium mb-2">
                              {' '}
                              Joint Account Members{' '}
                            </h1>
                          </div>
                        </div>
                        <div className="overflow-x-auto border-b ">
                          <table className="w-full h-full border-separate text-xs pb-4 border-[#EDEDED] border-spacing-y-2">
                            {/* Table Header */}
                            <thead className="text-[#8C8C8C] text-left text-sm">
                              <tr className="border border-[#EDEDED]">
                                {memberHeaders.map((header, index) => (
                                  <th
                                    key={header}
                                    className={`
            cursor-pointer px-2 py-2 mb-5 text-left font-medium
            ${index === 0 ? 'w-8' : 'w-40'} /* Make the first column narrower */
            ${
              index === 0
                ? 'border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]'
                : ''
            }
            ${
              index >= 1 && index <= 2
                ? 'border-t border-b border-[#EDEDED]'
                : ''
            }
            ${
              index === 3
                ? 'border-t border-b border-r rounded-tr-md rounded-br-md border-[#EDEDED]'
                : ''
            }
          `}
                                  >
                                    <span>{header}</span>
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody className="text-sm font-medium text-black">
                              {jointAccountActualMembers.length > 0 ? (
                                jointAccountActualMembers.map((member, idx) => (
                                  <tr key={idx} className="mb-2 bg-[#F9F9F9]">
                                    <td className="px-4 py-2 text-[#8C8C8C] w-8">
                                      {(idx + 1).toString().padStart(2, '0')}.
                                    </td>{' '}
                                    {/* Set width for first column */}
                                    <td className="px-2 text-left py-4 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                      <div className="flex flex-col text-left sm:flex-row justify-between items-start sm:items-center w-full gap-2">
                                        <span
                                          onClick={() => {
                                            let redirectState = {
                                              path: `/review-kyc-jointaccount-read-only/${member.userId.value}`,
                                              state: {
                                                from: location.pathname,
                                                historyStack: [
                                                  ...(location.state
                                                    ?.historyStack || []),
                                                  location.pathname,
                                                ],
                                              },
                                            };
                                            sessionStorage.setItem(
                                              'redirectAfterLogin',
                                              JSON.stringify(redirectState),
                                            );
                                            navigate(
                                              `/review-kyc-jointaccount-read-only/${member.userId.value}`,
                                              {
                                                state: {
                                                  from: location.pathname,
                                                  historyStack: [
                                                    ...(location.state
                                                      ?.historyStack || []),
                                                    location.pathname,
                                                  ],
                                                },
                                              },
                                            );
                                          }}
                                          className="break-words w-full sm:w-auto underline cursor-pointer"
                                        >
                                          {member.firstName.value}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="px-2 text-left py-4 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                      <div className="flex flex-col text-left sm:flex-row justify-between items-start sm:items-center w-full gap-2">
                                        <span className="break-words w-full sm:w-auto">
                                          {member.lastName.value}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="px-2 py-4 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full gap-2">
                                        <span className="break-words w-full sm:w-auto">
                                          {member.email.value}
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="text-center py-4" colSpan="7">
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                          <div className="flex flex-col px-2 md:pl-4 md:pr-0 pt-4">
                            {/* Label and Question */}
                            <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Is there going to be a Sole Signatory by
                                providing a Power Of Attorney?
                              </label>

                              {/* Radio Buttons */}
                              <div className="flex items-center gap-4">
                                <label className="flex items-center text-sm text-black">
                                  <input
                                    type="radio"
                                    name="signatory"
                                    value="yes"
                                    checked={signatory === 'yes'}
                                    className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                                  />
                                  <span className="ml-2">Yes</span>
                                </label>

                                <label className="flex items-center text-sm text-black">
                                  <input
                                    type="radio"
                                    name="signatory"
                                    value="no"
                                    checked={signatory === 'no'}
                                    className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                                  />
                                  <span className="ml-2">No</span>
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-2">
                            <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Select which joint account members are going to
                                be the signatories
                              </label>

                              {/* Radio Buttons */}
                              <div className="flex items-center gap-4">
                                <div className="mt-0 text-sm">
                                  {jointAccountName}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex lg:pt-4 pt-0 flex-col px-2">
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Power of Attorney
                              </label>
                            </div>
                            {fileAttorney && fileAttorney.value && (
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(fileAttorney.value);
                                }}
                                className="cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                              >
                                <div className="flex-col flex">
                                  <span className="text-black underline">
                                    {fileAttorney.value.file_name}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* End  */}
                </div>
              </div>
              {/* End  */}
              {/* Business Information */}
              {customerType.id == 5 && (
                <div className="w-full  p-4">
                  <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                    <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                      <div className="flex text-black items-center space-x-2">
                        <img
                          src="/buildings.svg"
                          alt="User Avatar"
                          className="h-6 w-6 mb-2"
                        />
                        <h1 className="text-md font-medium mb-2">
                          {' '}
                          Business Information
                        </h1>
                      </div>
                    </div>
                    {/* Will add popup here */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                      <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4 ">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center"
                          >
                            Tax Resident Country
                          </label>
                        </div>
                        <div className="mt-0 text-sm">
                          {taxResidentCountry?.value.name}
                        </div>
                        {taxResidentCountry?.value.id == 2 && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Country
                              </label>
                            </div>
                            <div className="mt-0 text-sm">
                              {nonResCountryText.value.name}
                            </div>
                          </>
                        )}
                        <>
                          {taxResidentCountry.value.id != 1 && (
                            <>
                              <div className="flex mt-2 items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Business Registration Number
                                </label>
                              </div>
                              <div className="mt-0 text-sm">
                                {businessRegistrationNumber.value}
                              </div>
                            </>
                          )}
                        </>

                        {taxResidentCountry.value.id == 1 && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                ABN
                              </label>
                            </div>
                            <div className="mt-0 text-sm">{abn.value}</div>
                          </>
                        )}
                        {taxResidentCountry.value.id == 3 && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Tax ID
                              </label>
                            </div>
                            <div className="mt-0 text-sm">{taxId.value}</div>
                          </>
                        )}
                      </div>
                      <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center"
                          >
                            Business Name
                          </label>
                        </div>
                        <div className="mt-0 text-sm">{businessName.value}</div>
                        <>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center  whitespace-normal words-break"
                            >
                              Describe the business activity
                            </label>
                          </div>
                          <div className="mt-0 text-sm">
                            {businessActivity.value.name}
                          </div>
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="mt-2 whitespace-normal words-break text-sm text-[#A6A6A6] w-40 md:w-full flex items-center"
                            >
                              Source of the funds including its origin
                            </label>
                          </div>
                          <div className="mt-0 text-sm">{fundSource.value}</div>
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="mt-2 whitespace-normal words-break text-sm text-[#A6A6A6] w-40 md:w-full flex items-center"
                            >
                              Purpose of opening account
                            </label>
                          </div>
                          <div className="mt-0 text-sm">
                            {accountPurpose.value}
                          </div>
                          {filePurpose && filePurpose.value && (
                            <>
                              {' '}
                              <div className="flex items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="mt-2 whitespace-normal words-break text-sm text-[#A6A6A6] w-40 md:w-full flex items-center"
                                >
                                  Additional documents
                                </label>
                              </div>
                              {filePurpose && filePurpose.value && (
                                <div
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileClick(filePurpose.value);
                                  }}
                                  className="cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                                >
                                  <div className="flex-col flex">
                                    <span className="text-black underline">
                                      {filePurpose.value.file_name}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      </div>
                      <div className="flex lg:pt-4 pt-0 flex-col px-4">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center  whitespace-normal words-break"
                          >
                            Address of Principal Place of Business
                          </label>
                        </div>
                        <div className="mt-0 text-sm">
                          {businessAddress.value.google_address}
                        </div>
                        <>
                          <div className="mt-2 flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className=" whitespace-normal words-break text-sm text-[#A6A6A6] w-40 md:w-full  flex items-center"
                            >
                              Nature and level of the intended transaction
                              behaviour
                            </label>
                          </div>
                          <div className="mt-0 text-sm">
                            {transactionNature.value}
                          </div>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className=" whitespace-normal words-break text-sm text-[#A6A6A6] w-40 md:w-full  flex items-center"
                            >
                              Beneficial ownership of the funds used by this
                              account
                            </label>
                          </div>
                          <div className="mt-0 text-sm">
                            {ownership.value == true ? 'Yes' : 'No'}
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* End  */}
              {/* Image section */}
              <div className="mt-4 px-4 flex flex-col md:flex-row gap-6 w-full">
                {' '}
                {/* IMAGE SECTION */}
                <div className="w-full md:max-w-[280px]">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500">Photo Upload</span>
                  </div>

                  <div className="mt-2 relative w-full h-44 rounded-xl overflow-hidden border bg-gray-50">
                    <img
                      src={image.value.presigned_url}
                      alt="Uploaded"
                      className="w-full h-full object-cover"
                    />

                    <button
                      onClick={() => setFullscreen(true)}
                      className="absolute top-2 right-2 bg-white/90 hover:bg-white p-2 rounded-full shadow transition"
                    >
                      <img src="/show-full.svg" className="w-4 h-4" />
                    </button>
                  </div>
                </div>
                {roleName === 'agency_compliance' && (
                  <div className="flex-1">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="text-sm font-semibold text-gray-700">
                        Team Member Meeting Status
                      </h3>

                      <span className="text-xs text-gray-400">
                        {meetingData?.length} team members
                      </span>
                    </div>

                    {/* Scrollable container for large lists */}
                    <div className="max-h-[420px] overflow-y-auto pr-2 space-y-3">
                      {meetingData?.map((agent) => (
                        <div
                          key={agent.agent_user_id}
                          className="flex items-center justify-between p-3 rounded-xl border bg-white hover:bg-gray-50 transition"
                        >
                          {/* LEFT: identity */}
                          <div className="flex items-center gap-3 min-w-0">
                            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center text-white text-sm font-semibold">
                              {agent.agent_name?.charAt(0) || 'A'}
                            </div>

                            <div className="min-w-0">
                              <p className="text-sm font-medium text-gray-800 truncate">
                                {agent.agent_name}
                              </p>
                              <p className="text-xs text-gray-500 truncate">
                                {agent.agent_email}
                              </p>
                            </div>
                          </div>

                          {/* RIGHT: status */}
                          <div className="flex items-center gap-3">
                            <span
                              className={`text-[11px] px-2 py-1 rounded-full font-medium border ${
                                agent.has_met_customer
                                  ? 'bg-green-50 text-green-600 border-green-200'
                                  : 'bg-red-50 text-red-600 border-red-200'
                              }`}
                            >
                              {agent.has_met_customer ? 'Met' : 'Not Met'}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              {fullscreen && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 py-6"
                  onClick={() => setFullscreen(false)}
                >
                  <img
                    src={image.value.presigned_url}
                    alt="Fullscreen"
                    className="max-w-full max-h-full object-contain rounded-2xl shadow-lg"
                  />
                </div>
              )}
              {/* End */}
              {/* Upload Proof Documents */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                  <div className="flex flex-wrap md:flex-nowrap items-center justify-between border-colour-custom pt-2 px-4 gap-4">
                    {/* Left Section (Title + Icon) */}
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/note-2.svg"
                        alt="User Avatar"
                        className="h-6 w-6"
                      />
                      <h1 className="text-md font-medium">
                        Upload Proof Documents
                      </h1>
                    </div>
                    {/* <div className="p-4">
                      <StatusDropdown
                        value={
                          customerType.id == 5
                            ? statusData[3].status
                            : statusData[2].status
                        }
                        onChange={(val) => {
                          setLoadingUpdate(true);
                          if (customerType.id == 5) {
                            handleUpdateSection(val, statusData[3].id);
                          } else {
                            handleUpdateSection(val, statusData[2].id);
                          }
                        }}
                      />
                    </div> */}
                  </div>

                  {/* Will add popup here */}
                  <div className="grid grid-cols-1 pb-4 mx-4 border-b sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col   md:pl-4 md:pr-0 pt-4 ">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="whitespace-normal break-words text-sm text-[#A6A6A6] w-40 md:w-full flex items-center"
                        >
                          Details of any current or recent prosecutions and
                          inquiries related to Money Laundering, terrorist
                          links, tax offences and corruption in respect of the
                          Individual
                        </label>
                        <StatusButton
                          status={thirdPartySign.status}
                          count={thirdPartySign.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              thirdPartySign,
                              'Details of any current or recent prosecutions and inquiries related to Money Laundering, terrorist links, tax offences and corruption in respect of the Individual',
                              thirdPartySign.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="thirdPartySign"
                            value="yes"
                            checked={thirdPartySign.value === true}
                            className="w-6 comfirm-check h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="thirdPartySign"
                            value="no"
                            checked={thirdPartySign.value === false}
                            className="w-6 h-4 confirm-check border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>{' '}
                      {thirdPartySign.value === true && (
                        <>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Description
                            </label>
                            <StatusButton
                              status={description.status}
                              count={description.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  description,
                                  'Description',
                                  description.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {description.value}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 md:pl-4 pr-2">
                      {thirdPartySign.value === true && (
                        <>
                          <FileUploadDisplay
                            label="Upload Proof"
                            fileData={fileProof}
                            onFileClick={handleFileClick}
                          />
                        </>
                      )}
                    </div>
                    <div className="flex lg:pt-4 pt-0 md:pl-4 pr-2 flex-col"></div>
                  </div>
                  {/* Extra details */}
                  <div className="grid grid-cols-1 pb-4 pt-2 mx-4 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col tex-xs ">
                      {applicantCountry.value.id == 14 && (
                        <>
                          <div className="flex items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Photographic ID
                            </label>
                          </div>
                          <div className="mt-0 text-sm  md:pr-0">
                            {photoIdText}
                          </div>
                          {(photoId == 1 || photoId == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoId == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                fileData={filePhotographicId}
                                onFileClick={handleFileClick}
                              />
                              {photoId == 1 && (
                                <>
                                  <div className="mt-2 flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Passport Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      count={documentNumber.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          'Passport Number',
                                          documentNumber.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                              {photoId == 3 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Document Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      count={documentNumber.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          'Document Number',
                                          documentNumber.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                            </>
                          )}
                          {photoId == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFront}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBack}
                                onFileClick={handleFileClick}
                              />
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Driver's License Number
                                </label>
                                <StatusButton
                                  status={documentNumber.status}
                                  count={documentNumber.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      documentNumber,
                                      "Driver's License Number",
                                      documentNumber.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{documentNumber.value}</span>
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Card Number
                                </label>
                                <StatusButton
                                  status={cardNumber.status}
                                  count={cardNumber.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      cardNumber,
                                      'Card Number',
                                      cardNumber.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{cardNumber.value}</span>
                            </>
                          )}
                          <div className="flex items-center justify-between  md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Expiry Date
                            </label>
                            <StatusButton
                              status={expiryDate.status}
                              count={expiryDate.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  expiryDate,
                                  ' Expiry Date',
                                  expiryDate
                                    ? new Date(
                                        expiryDate.value,
                                      ).toLocaleDateString('en-GB')
                                    : '',
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {expiryDate
                              ? new Date(expiryDate.value).toLocaleDateString(
                                  'en-GB',
                                )
                              : ''}
                          </div>
                        </>
                      )}
                      {applicantCountry.value.id != 14 && (
                        <>
                          <div className="flex items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                            >
                              Select First Photographic ID
                            </label>
                          </div>
                          <div className="mt-0 text-sm  md:pr-0">
                            {photoIdFirstText}
                          </div>
                          {(photoIdFirst == 1 || photoIdFirst == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoIdFirst == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                fileData={filePhotographicIdFirst}
                                onFileClick={handleFileClick}
                              />
                              {photoIdFirst == 1 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Passport Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      count={documentNumber.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          'Passport Number',
                                          documentNumber.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                              {photoIdFirst == 3 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Document Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      count={documentNumber.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          'Document Number',
                                          documentNumber.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                            </>
                          )}
                          {photoIdFirst == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFrontFirst}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBackFirst}
                                onFileClick={handleFileClick}
                              />

                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Driver's License Number
                                </label>
                                <StatusButton
                                  status={documentNumber.status}
                                  count={documentNumber.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      documentNumber,
                                      "Driver's License Number",
                                      documentNumber.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{documentNumber.value}</span>
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Card Number
                                </label>
                                <StatusButton
                                  status={cardNumber.status}
                                  count={cardNumber.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      cardNumber,
                                      'Card Number',
                                      cardNumber.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{cardNumber.value}</span>
                            </>
                          )}
                          <div className="flex items-center justify-between  md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Expiry Date
                            </label>
                            <StatusButton
                              status={expiryDate.status}
                              count={expiryDate.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  expiryDate,
                                  'Expiry Date',
                                  expiryDate
                                    ? new Date(
                                        expiryDate.value,
                                      ).toLocaleDateString('en-GB')
                                    : '',
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {expiryDate
                              ? new Date(expiryDate.value).toLocaleDateString(
                                  'en-GB',
                                )
                              : ''}
                          </div>
                          <div className="flex items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                            >
                              Select Second Photographic ID
                            </label>
                          </div>
                          <div className="mt-0 text-sm  md:pr-0">
                            {photoIdSecondText}
                          </div>
                          {(photoIdSecond == 1 || photoIdSecond == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoIdSecond == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                fileData={filePhotographicIdSecond}
                                onFileClick={handleFileClick}
                              />
                              {photoIdSecond == 1 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Passport Number
                                    </label>
                                    <StatusButton
                                      status={documentNumberSecond.status}
                                      count={
                                        documentNumberSecond.comments?.length
                                      }
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumberSecond,
                                          'Passport Number',
                                          documentNumberSecond.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumberSecond.value}</span>
                                </>
                              )}
                              {photoIdSecond == 3 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Document Number
                                    </label>
                                    <StatusButton
                                      status={documentNumberSecond.status}
                                      count={
                                        documentNumberSecond.comments?.length
                                      }
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumberSecond,
                                          'Document Number',
                                          documentNumberSecond.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumberSecond.value}</span>
                                </>
                              )}
                            </>
                          )}
                          {photoIdSecond == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFrontSecond}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBackSecond}
                                onFileClick={handleFileClick}
                              />
                              <div className="flex items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                >
                                  Driver's License Number
                                </label>
                                <StatusButton
                                  status={documentNumberSecond.status}
                                  count={documentNumberSecond.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      documentNumberSecond,
                                      "Driver's License Number",
                                      documentNumberSecond.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{documentNumberSecond.value}</span>
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Card Number
                                </label>
                                <StatusButton
                                  status={cardNumberSecond.status}
                                  count={cardNumberSecond.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      cardNumberSecond,
                                      'Card Number',
                                      cardNumberSecond.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{cardNumberSecond.value}</span>
                            </>
                          )}
                          <div className="flex items-center justify-between  md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Expiry Date
                            </label>
                            <StatusButton
                              status={expiryDateSecond.status}
                              count={expiryDateSecond.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  expiryDateSecond,
                                  'Expiry Date',
                                  expiryDateSecond
                                    ? new Date(
                                        expiryDateSecond.value,
                                      ).toLocaleDateString('en-GB')
                                    : '',
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {expiryDateSecond
                              ? new Date(
                                  expiryDateSecond.value,
                                ).toLocaleDateString('en-GB')
                              : ''}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="flex px-2 flex-col lg:pt-2 pt-0  sm:border-l-0 sm:border-r-0 md:border-r border-gray-300 ">
                      {photoId != 2 && (
                        <>
                          <div className="flex items-center justify-between ">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] w-40 md:w-full flex items-center"
                            >
                              Non Photographic ID
                            </label>
                          </div>
                          <span>{nonphotoIdText.value}</span>
                          <FileUploadDisplay
                            label="Uploaded Document"
                            fileData={fileNonPhotographicId}
                            onFileClick={handleFileClick}
                          />
                        </>
                      )}
                    </div>

                    <div className="flex lg:pt-2 pt-0 flex-col"></div>
                  </div>
                </div>
              </div>
              {/* End  */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/profile-circle-black.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {' '}
                        Scan Results
                      </h1>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
                    {/* Column 1 */}
                    <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4">
                      <label className="text-sm text-[#A6A6A6]">
                        Verification Status
                      </label>
                      <div className="text-sm break-words max-w-full">
                        <button
                          className={` w-40 mt-1 text-left cursor-text font-medium  rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                            verificationStatus.code == 'Y'
                              ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                              : ''
                          }
                                  ${
                                    verificationStatus.code == 'N'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
  
                              `}
                        >
                          <span className="mr-6 text-left">
                            {verificationStatus?.label}
                          </span>
                        </button>
                      </div>

                      <label className="mt-2 text-sm text-[#A6A6A6]">
                        Date
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {formatDateTimeUTC(dvsTime)}
                      </div>
                    </div>

                    {/* Column 2 */}
                    <div className="flex flex-col lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l border-gray-300 px-4">
                      <label className="text-sm text-[#A6A6A6]">Message</label>
                      <div className="text-sm break-all whitespace-normal max-w-full">
                        {dvsMeessage}
                      </div>
                    </div>

                    {/* Column 3 */}
                    <div className="flex flex-col lg:pt-4 pt-0 px-4"></div>
                  </div>
                </div>
              </div>
              <div className="w-full  pm-4">
                <div className="bg-gradient-to-br from-gray-50 via-white to-gray-100 p-5 mt-4 rounded-2xl border space-y-6">
                  {/* HEADER */}
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                    <div>
                      <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                        👤{' '}
                        <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                          {fullNameSanction}
                        </span>
                      </h2>
                      <p className="text-xs text-gray-500">
                        Full Screening Overview
                      </p>
                    </div>
                  </div>

                  {/* SCORE + SUMMARY */}
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-white/80 backdrop-blur p-4 rounded-2xl border shadow-sm hover:shadow-md transition">
                      <p className="text-xs text-gray-500 flex items-center gap-1">
                        📅 Last Screening
                      </p>
                      <h2 className="text-lg font-semibold text-gray-800">
                        {screeningDate}
                      </h2>
                      <p className="text-xs text-gray-400">
                        Auto-updated in real time
                      </p>
                    </div>

                    <div className="bg-white/80 backdrop-blur p-4 rounded-2xl border shadow-sm hover:shadow-md transition">
                      <p className="text-xs text-gray-500 flex items-center gap-1">
                        🛡️ Compliance Status
                      </p>
                      <h2
                        className={`text-lg font-semibold ${compliance.color}`}
                      >
                        {compliance.label}
                      </h2>
                      <p className="text-xs text-gray-400">{compliance.sub}</p>
                    </div>
                  </div>

                  {/* CHECKS GRID */}
                  <div className="grid md:grid-cols-3 gap-4">
                    <div className="hover:scale-[1.02] transition">
                      <CheckItem
                        label="Sanctions Screening"
                        status={sanctionsStatus}
                      />
                    </div>
                    <div className="hover:scale-[1.02] transition">
                      <CheckItem label="PEP Check" status={pepStatus} />
                    </div>
                    <div className="hover:scale-[1.02] transition">
                      <CheckItem label="Adverse Media" status={adverseStatus} />
                    </div>
                  </div>

                  {/* SOURCES SECTION */}
                  <div className="bg-white/90 backdrop-blur p-5 rounded-2xl border shadow-sm space-y-6">
                    {/* Checked Sources */}
                    <div>
                      <h3 className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
                        🔍 Sources Checked
                        <span className="text-[10px] px-2 py-0.5 rounded-full bg-blue-50 text-blue-600 border border-blue-200">
                          {sourcesChecked.length}
                        </span>
                      </h3>
                      <div className="flex flex-wrap gap-2">
                        {sourcesChecked.length > 0 ? (
                          sourcesChecked.map((source, index) => {
                            const isMatched = matchedSources.includes(source);

                            return (
                              <span
                                key={index}
                                className={`px-3 py-1 text-xs rounded-full border flex items-center gap-1 transition-all duration-200 hover:scale-105 ${getSourceStyle(
                                  source,
                                  isMatched,
                                )}`}
                              >
                                {isMatched ? '⚠️' : '✔️'}

                                {formatSourceName(source)}

                                {isMatched && (
                                  <span className="ml-1 text-[10px] font-medium">
                                    (Match)
                                  </span>
                                )}
                              </span>
                            );
                          })
                        ) : (
                          <p className="text-xs text-gray-400">
                            No sources available
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Matched Sources */}
                    <div>
                      <h3 className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
                        🎯 Matched Sources
                      </h3>

                      {matchedSources.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                          {matchedSources.map((source, index) => (
                            <span
                              key={index}
                              className="px-3 py-1 text-xs rounded-full border flex items-center gap-1 bg-gradient-to-r from-red-50 to-pink-50 text-red-600 border-red-200 shadow-sm hover:scale-105 transition"
                            >
                              ⚠️ {source}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <div className="flex items-center gap-2 text-xs text-green-700 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 px-3 py-2 rounded-lg">
                          ✅ No matches found across all screened sources
                        </div>
                      )}
                    </div>
                  </div>

                  {/* INSIGHT PANEL */}
                  <div className="bg-white/90 backdrop-blur p-4 rounded-2xl border shadow-sm hover:shadow-md transition">
                    <h3 className="text-sm font-semibold text-gray-800 mb-2 flex items-center gap-2">
                      🧠 Compliance Insight Summary
                    </h3>

                    <p className="text-xs text-gray-600 leading-relaxed">
                      {uiSummary || 'No summary available'}
                    </p>
                  </div>
                </div>
              </div>
              {(pendingQuestions.length > 0 || completedGroups.length > 0) && (
                <div className="bg-white rounded-2xl p-4">
                  <div className="bg-white border rounded-2xl p-4 mt-4">
                    {pendingQuestions.length > 0 && (
                      <div className="w-full p-4">
                        <UserQuestionnaire
                          apidata={pendingQuestions}
                          customerName={firstNameSignup + ' ' + lastNameSignup}
                          isPending={true}
                          isReadOnly={true}
                          heading={'Customer Submitted ECDD Responses'}
                        />
                      </div>
                    )}
                    {completedGroups.length > 0 && (
                      <div className="w-full p-4">
                        <UserQuestionnaire
                          apidata={completedGroups}
                          customerName={firstNameSignup + ' ' + lastNameSignup}
                          isPending={false}
                          isReadOnly={true}
                          heading={'Customer Submitted ECDD Responses'}
                        />
                      </div>
                    )}{' '}
                  </div>
                </div>
              )}
              {isModalOpen && currentDocument && (
                <DocumentPreview
                  fileUrl={currentDocument.presigned_url}
                  fileName={currentDocument.file_name}
                  onClose={() => setIsModalOpen(false)}
                />
              )}
              {showModal && (
                <EDDModal
                  pendingQuestions={pendingQuestions}
                  completedQuestions={completedQuestions}
                  closeModal={() => {
                    setShowModal(false);
                    getEddResponses();
                  }}
                />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};
const CheckItem = ({ label, status }) => {
  const styles = {
    completed: 'bg-emerald-50 text-emerald-700 border-emerald-100',
    found: 'bg-red-50 text-red-700 border-red-100',
    warn: 'bg-amber-50 text-amber-700 border-amber-100',
  };

  const icons = {
    completed: '✔',
    found: '✖',
    warn: '⚠',
  };

  return (
    <div
      className={`flex justify-between items-center p-3 rounded-xl border shadow-sm ${styles[status]} transition hover:shadow-md`}
    >
      <span className="text-xs font-medium text-gray-800">{label}</span>

      <span className="text-xs font-semibold flex items-center gap-1">
        {icons[status]} {status.toUpperCase()}
      </span>
    </div>
  );
};
export default ReviewKycReadOnly;
